// ready(function () {
//   htmx.on('htmx:afterSwap', function(event) {
//     if (event.target.querySelector('form')) {
//       setTimeout(initFormJs, 100);
//     }
//   });

//   function initFormJs() {
//     console.log('initFormJs');
//     const absenceFormWrapper = document.getElementById('absenceFormWrapper');
//     if (absenceFormWrapper) {
//     	refreshCsrf();
//     	hideHoneypot();
//     	setConditionalFields();
//     }
//   }
//   initFormJs();

//   function refreshCsrf(){
//     console.log('refreshCsrf');
//   //   var form = document.querySelector('form');
//   //   if (form) {
//   //     var csrfInput = form.querySelector('input[name="{{ craft.app.config.general.csrfTokenName|e('js') }}"]');
//   //     csrfInput.value = "{{ craft.app.request.csrfToken|e('js') }}";
//   //   }
//   }

//   function hideHoneypot() {
//     console.log('hideHoneypot');
//     const honeypotLabel = document.querySelector('label[for="freeform_form_handle"]');
//     const honeypotInput = document.querySelector('input[name="freeform_form_handle"]');
//     if (honeypotInput) {
//       honeypotLabel.style.display = 'none';
//       honeypotInput.style.display = 'none';
//     }
//   }

//   function setConditionalFields(){
//     console.log('setConditionalFields');
//     const disciplineInput = document.querySelector('#form-input-discipline');
//     const teacherInput = document.querySelector('.container__wrapper[data-field-container="professeur"]');
//     if (disciplineInput && teacherInput) {
//       // -- hide inputs --
//       teacherInput.style.display = 'none';
//       // -- listen change event --
//       disciplineInput.addEventListener('change', function () {
//         if (disciplineInput.value) {
//           teacherInput.style.display = 'block';
//         } else {
//           teacherInput.style.display = 'none';
//         }
//       });
//     }
//   }

// });